import PhotoGalleryModal from "./PhotoGalleryModal";

export default PhotoGalleryModal;